import type { FC } from 'react';
import { ToastContainer } from 'react-toastify';
import { selectChangeStatusDelay, selectIsCouponQuickBetsV2, selectorCouponHistoryIsLoadedV2, selectorCouponHistoryIsLoadingV2, selectorCouponHistoryOpenCouponsV2, selectShowProgress, selectUserIsAuthenticated } from '@mwl/core-lib';
import { NoSSR } from '@mwl/ui';
import { Loader } from '@/components/Loader/Loader';
import { betsToastContainerId } from '@/constants';
import { useTypedSelector } from '@/hooks';
import { commonToastOptions } from '../../SportCoupon.data';
import { useCouponNotifications } from '../../SportCoupon.hooks';
import { CouponBetsHistoryEmpty } from '../CouponBetsHistoryEmpty/CouponBetsHistoryEmpty';
import { CouponBetsHistoryItem } from '../CouponBetsHistoryItem/CouponBetsHistoryItem';
import { CouponCreateProgress } from '../CouponCreateProgress/CouponCreateProgress';
import { CouponQuickBetSwitch } from '../CouponQuickBetSwitch/CouponQuickBetSwitch';
import { CouponSum } from '../CouponSum/CouponSum';
import styles from './CouponBetsHistory.module.scss';
const CouponBetsHistory: FC = () => {
  const openedCoupons = useTypedSelector(selectorCouponHistoryOpenCouponsV2);
  const isLoading = useTypedSelector(selectorCouponHistoryIsLoadingV2);
  const isLoaded = useTypedSelector(selectorCouponHistoryIsLoadedV2);
  const isAuth = useTypedSelector(selectUserIsAuthenticated);
  const isQuickBets = useTypedSelector(selectIsCouponQuickBetsV2);
  const statusDelay = useTypedSelector(selectChangeStatusDelay);
  const isEmpty = !isAuth || !openedCoupons?.length;
  const isShowLoader = isAuth && !isLoaded && isLoading;
  const isShowProgress = useTypedSelector(selectShowProgress);
  useCouponNotifications(betsToastContainerId);
  if (isShowLoader) {
    return <div className={styles.loader}>
        <Loader />
      </div>;
  }
  return <NoSSR data-sentry-element="NoSSR" data-sentry-component="CouponBetsHistory" data-sentry-source-file="CouponBetsHistory.tsx">
      <div className={styles.root}>
        <div className={styles.topWrapper}>
          <ToastContainer {...commonToastOptions} position="top-center" containerId={betsToastContainerId} data-sentry-element="ToastContainer" data-sentry-source-file="CouponBetsHistory.tsx" />
          <div className={styles.topWrapperContent}>
            <CouponQuickBetSwitch disabled={!isAuth} data-sentry-element="CouponQuickBetSwitch" data-sentry-source-file="CouponBetsHistory.tsx" />
            {isQuickBets && !isShowProgress && <CouponSum />}
            {isShowProgress && <CouponCreateProgress duration={statusDelay || 10000} size="large" />}
          </div>
        </div>
        {isEmpty && <CouponBetsHistoryEmpty />}
        {!isEmpty && <div className={styles.betsListWrapper}>
            {!!openedCoupons?.length && openedCoupons.map(coupon => <CouponBetsHistoryItem {...coupon} key={coupon.id} />)}
          </div>}
      </div>
    </NoSSR>;
};
export { CouponBetsHistory };